export default function Navbar() {
    return (
        <div className="fixed top-0 left-0 text-center z-10 w-full header bg-violet-600 py-4 text-white font-bold text-lg shadow-lg">
            Advanced Todo Application with RTK Query
        </div>
    );
}
